import { AfterViewInit, Directive, ElementRef, Inject, input, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({ selector: '[appAutofocus]' })
export class AutofocusDirective implements AfterViewInit {

  appAutofocus = input<boolean>(true);

  constructor(
    private elementRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  ngAfterViewInit(): void {
    if (!this.appAutofocus() || !isPlatformBrowser(this.platformId)) {
      return;
    }

    this.elementRef.nativeElement.focus();
  }
}
